import { View, Text, TouchableOpacity } from "react-native";
import React, { useEffect, useState, useRef } from "react";

import Fonts from "../../Resources/Fonts";
import GlobalStyles from "../../Resources/Styles";
import Colors from "../../Resources/Color";
import { Menu, MenuItem, MenuDivider } from "react-native-material-menu";
import { Entypo } from "@expo/vector-icons";
import { observer } from "mobx-react";
import Workout from "../Firestore/Workout";
import Exercise from "../Firestore/Exercise";
import Serie from "../Firestore/Serie";
import Attribute from "../Firestore/Attribute";
import AddWorkoutView from "./AddWorkoutView";

import { Ionicons } from "@expo/vector-icons";
import { FontAwesome5 } from "@expo/vector-icons";
import { format } from "date-fns";

import CustomAlert from "../Components/CustomAlert";
import { useDevice, useScreenDimensions } from "../_layout";

import { useTranslation } from "react-i18next";
import { useDrag, useDrop } from "react-dnd";
import { useToast } from "../contexts/ToastContext";

const WorkoutRowView = observer(({ workout, index, moveWorkout }) => {
  const { t, i18n } = useTranslation();
  const { isMobile } = useDevice();

  const [showingChangeWorkoutName, setShowingChangeWorkoutName] =
    useState(false);
  const { screenSize } = useScreenDimensions();

  const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
  const deleteAlertTitle = "deleteWorkoutAlertTitle-string";
  const deleteAlertText = "deleteWorkoutAlert-string";

  const [
    showingConflictingExercisesAlert,
    setShowingConflictingExercisesAlert,
  ] = useState();
  const [conflictingExerciseSlots, setConflictingExerciseSlots] = useState("");

  const [isHovered, setIsHovered] = useState(false);
  const [isMenuHovered, setIsMenuHovered] = useState(false);

  const [workoutMenu, setWorkoutMenu] = useState(false);
  const showWorkoutMenu = () => setWorkoutMenu(true);

  const [weekMenu, setWeekMenu] = useState(false);
  const [isCopyingWorkout, setIsCopyingWorkout] = useState(true);

  // derive an array of conflicting exercise names
  const conflictNamesArray = conflictingExerciseSlots
    .split("\n")
    .filter((n) => n);

  const action = () => {
    if (!showingChangeWorkoutName) {
      workout.block.setSelectedWorkout(workout);
    }
  };

  const deleteWorkout = () => {
    workout.block.deleteWorkout(workout);
    setWorkoutMenu(false);
  };

  const WeekMenuSelector = () => {
    // Helper to check protocolSlot conflicts for a given week
    const checkProtocolSlotConflict = (targetWeek) => {
      const existingWorkouts = workout.block.workouts.filter(
        (w) => w.week === targetWeek
      );
      const currentSlots = workout.exercises
        .filter((ex) => ex.protocolSlot)
        .map((ex) => ex.protocolSlot);
      const conflict = existingWorkouts.some((w) =>
        w.exercises.some((ex) => currentSlots.includes(ex.protocolSlot))
      );
      if (conflict) {
        const existingSlots = existingWorkouts.flatMap((w) =>
          w.exercises.map((ex) => ex.protocolSlot)
        );
        const conflictSlots = currentSlots.filter((slot) =>
          existingSlots.includes(slot)
        );
        const conflictNames = workout.exercises
          .filter((ex) => conflictSlots.includes(ex.protocolSlot))
          .map((ex) => t(ex.protocolSlot));
        setConflictingExerciseSlots(conflictNames.join("\n"));
        console.log("conflictNames", conflictNames);
        setWeekMenu(false);
        setShowingConflictingExercisesAlert(true);
        return true;
      }
      setConflictingExerciseSlots("");
      return false;
    };

    const MenuItemView = ({ index }) => {
      const [isHovered, setIsHovered] = useState(false);

      const copyWorkout = (newWeek) => {
        if (checkProtocolSlotConflict(newWeek)) return;

        const maxOrder = Math.max(
          ...workout.block.workouts
            .filter((w) => w.week === newWeek)
            .map((w) => w.order)
        );
        const newWorkout = new Workout(
          undefined,
          null,
          workout.name,
          maxOrder + 1,
          newWeek,
          true,
          workout.block,
          []
        );
        // newWorkout.setProperty("weekDay", workout.getWeekDay);
        workout.exercises?.forEach((exercise) => {
          const newExercise = new Exercise(
            undefined,
            exercise.name,
            exercise.originalName,
            exercise.notes,
            exercise.order,
            true,
            false,
            newWorkout,
            [],
            [],
            undefined,
            undefined,
            exercise.link
          );

          newExercise.setProperty("protocolSlot", exercise.protocolSlot);
          newExercise.setProperty("protocolText", exercise.protocolText);
          newExercise.setProperty(
            "isSecondaryProtocol",
            exercise.isSecondaryProtocol
          );

          exercise.series?.forEach((serie) => {
            const newSerie = new Serie(
              undefined,
              serie.order,
              serie.reps,
              serie.rpe,
              serie.weight,
              serie.targetReps,
              serie.targetRpe,
              serie.targetWeight,
              newExercise,
              serie.relevance,
              undefined,
              serie.requireVideo
            );
            newExercise.series.push(newSerie);
          });

          exercise.attributes?.forEach((attribute) => {
            const newAttribute = new Attribute(
              undefined,
              attribute.name,
              attribute.title,
              attribute.subtitle,
              attribute.order,
              false,
              attribute.isSelected,
              null,
              newExercise
            );
            newExercise.attributes.push(newAttribute);
          });

          newWorkout.exercises.push(newExercise);
        });

        workout.block.workouts.push(newWorkout);
        // newWorkout.block.toggleHasChanged();
        newWorkout.block.client.updateClientTransactionData(
          newWorkout.block.id
        );
        newWorkout.setProperty("hasChanged", true);
        newWorkout.block.client.startOrResetBatchTimer();

        newWorkout.block.setProperty("selectedWeek", newWeek);
        setWeekMenu(false);
      };

      const moveWorkoutWeek = (newWeek) => {
        if (checkProtocolSlotConflict(newWeek)) return;
        const maxOrder = Math.max(
          ...workout.block.workouts
            .filter((w) => w.week === newWeek)
            .map((w) => w.order)
        );
        workout.order = maxOrder + 1;
        workout.week = newWeek;
        workout.isSelected = true;

        workout.block.client.updateClientTransactionData(workout.block.id);
        workout.setProperty("hasChanged", true);
        workout.block.client.startOrResetBatchTimer();

        workout.block.setProperty("selectedWeek", newWeek);
        setWeekMenu(false);
      };

      return (
        <MenuItem
          onPress={() =>
            isCopyingWorkout
              ? copyWorkout(index + 1)
              : moveWorkoutWeek(index + 1)
          }
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          style={{ minWidth: 150 }}
          textStyle={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
          }}
        >
          {t("weekWithNumber-string", { week: index + 1 })}
        </MenuItem>
      );
    };
    return (
      <Menu
        visible={weekMenu}
        style={GlobalStyles.menu}
        onRequestClose={() => setWeekMenu(false)}
      >
        {Array.from({ length: workout.block.getWeeks }, (_, index) => (
          <MenuItemView index={index} key={index} />
        ))}
      </Menu>
    );
  };

  const onClose = () => {
    setWorkoutMenu(false);
    setIsHovered(false);
  };

  const MenuItemView = ({ option }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { showToast } = useToast();

    const showChangeName = () => {
      onClose();
      setShowingChangeWorkoutName(true);
      setWorkoutMenu(false);
    };

    const showDeleteAlert = () => {
      setShowingDeleteAlert(true);
      setWorkoutMenu(false);
      onClose();
    };

    const addToLibrary = () => {
      setWorkoutMenu(false);
      workout.copyToLibrary(showToast);
      onClose();
    };

    const deleteFromCalendar = () => {
      workout.date = null;
      setWorkoutMenu(false);
    };

    const selectWeek = () => {
      setWorkoutMenu(false);
      setWeekMenu(true);
      onClose();
    };

    return option === 1 ? (
      <MenuItem
        onPress={showChangeName}
        style={{ minWidth: 180 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("changeName-string")}
      </MenuItem>
    ) : option === 2 ? (
      <MenuItem
        onPress={() => {
          selectWeek();
          setIsCopyingWorkout(true);
          onClose();
        }}
        style={{ minWidth: 180 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("copyToAnotherWeek-string")}
      </MenuItem>
    ) : option === 3 ? (
      <>
        {workout.block &&
          workout.block.workouts.filter(
            (w) => w.week === workout.block.selectedWeek
          ).length > 1 && (
            <MenuItem
              onPress={() => {
                selectWeek();
                setIsCopyingWorkout(false);
                onClose();
              }}
              style={{ minWidth: 180 }}
              textStyle={{
                fontSize: 14,
                fontWeight: isHovered ? "600" : "normal",
              }}
              onMouseEnter={() => !isMobile && setIsHovered(true)}
              onMouseLeave={() => setIsHovered(false)}
            >
              {t("moveToAnotherWeek-string")}
            </MenuItem>
          )}
      </>
    ) : option === 4 ? (
      <MenuItem
        onPress={addToLibrary}
        style={{ minWidth: 180 }}
        textStyle={{ fontSize: 14, fontWeight: isHovered ? "600" : "normal" }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {t("exportToLibrary-string")}
      </MenuItem>
    ) : option === 5 ? (
      <>
        {workout.date && (
          <MenuItem
            onPress={deleteFromCalendar}
            style={{ minWidth: 180 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {t("deleteWorkoutFromCalendar-string")}
          </MenuItem>
        )}
      </>
    ) : (
      <>
        {workout.block && workout.block.workouts.length > 1 && (
          <MenuItem
            onPress={showDeleteAlert}
            style={{ minWidth: 180 }}
            textStyle={{
              fontSize: 14,
              fontWeight: isHovered ? "600" : "normal",
              color: "red",
            }}
            onMouseEnter={() => !isMobile && setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
          >
            {t("delete-string")}
          </MenuItem>
        )}
      </>
    );
  };

  //D&S
  const ref = React.useRef(null);

  const [, drop] = useDrop({
    accept: "workout",
    hover(item, monitor) {
      if (!ref.current) return;
      const dragIndex = item.index;
      const hoverIndex = index;
      if (dragIndex === hoverIndex) return;

      const hoverBoundingRect = ref.current.getBoundingClientRect();

      if (screenSize === "large") {
        // Vertical sorting - use 25% of Y height
        const hoverTriggerY =
          (hoverBoundingRect.bottom - hoverBoundingRect.top) * 0.25;

        const clientOffset = monitor.getClientOffset();
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverTriggerY) return;
        if (
          dragIndex > hoverIndex &&
          hoverClientY > hoverBoundingRect.bottom - hoverTriggerY
        )
          return;
      } else {
        const hoverTriggerX =
          (hoverBoundingRect.right - hoverBoundingRect.left) * 0.25;

        const clientOffset = monitor.getClientOffset();
        const hoverClientX = clientOffset.x - hoverBoundingRect.left;

        if (dragIndex < hoverIndex && hoverClientX < hoverTriggerX) return;
        if (
          dragIndex > hoverIndex &&
          hoverClientX > hoverBoundingRect.right - hoverTriggerX
        )
          return;
      }

      moveWorkout(dragIndex, hoverIndex);

      item.index = hoverIndex;
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: "workout",
    item: { type: "workout", id: workout.id, index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <View
      style={{
        width:
          screenSize === "large"
            ? "100%"
            : `calc((100% - ${screenSize === "small" ? 16 : 48}px) / ${
                screenSize === "small" ? 3 : 5
              })`,
      }}
      ref={ref}
    >
      <TouchableOpacity
        onPress={action}
        style={[
          GlobalStyles.touchableRow,
          {
            shadowColor: Colors.bubbleColor,
            borderWidth: isDragging ? 1.5 : workout.isSelected ? 1 : 0.1,
            borderColor:
              workout.isSelected || isDragging
                ? Colors.blackColor
                : isHovered
                ? "rgba(0, 0, 0, 0.5)"
                : Colors.borderColor,

            backgroundColor:
              isDragging && isMobile
                ? "rgba(0, 0, 0, 0.10)"
                : Colors.whiteColor,
          },
        ]}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View style={{ alignItems: "flex-start", flex: 1 }}>
          <Text
            numberOfLines={2}
            style={[
              screenSize != "large" ? Fonts.medium14 : Fonts.medium14,
              { width: "90%", marginBottom: 8 },
            ]}
          >
            {workout.name}
          </Text>
          <View style={GlobalStyles.HStack}>
            <Ionicons
              name="calendar"
              size={12}
              color={Colors.bubbleColor}
              style={{ paddingRight: 2 }}
            />
            <Text
              style={{
                // paddingRight: 20,
                fontSize: screenSize != "large" ? 11 : 12,
                color: "gray",
              }}
              numberOfLines={1}
            >
              {workout.date
                ? format(workout.date, "dd/MM/yy")
                : t("withoutDate-string")}
            </Text>
          </View>
        </View>
        <WeekMenuSelector />

        {(isHovered || isMobile) && (
          <Menu
            visible={workoutMenu}
            anchor={
              <TouchableOpacity
                onPress={() => {
                  showWorkoutMenu();
                }}
                onMouseEnter={() => !isMobile && setIsMenuHovered(true)}
                onMouseLeave={() => setIsMenuHovered(false)}
              >
                <Entypo
                  name="dots-three-horizontal"
                  size={screenSize != "large" ? 20 : 22}
                  color="black"
                  style={{ opacity: isMenuHovered ? 0.5 : 1 }}
                />
              </TouchableOpacity>
            }
            style={GlobalStyles.menu}
            onRequestClose={() => {
              setWorkoutMenu(false);
              setIsHovered(false);
            }}
          >
            <MenuItemView option={1} />
            <MenuItemView option={2} />
            <MenuItemView option={3} />
            <MenuItemView option={4} />
            <MenuItemView option={5} />
            <MenuItemView option={6} />
          </Menu>
        )}
      </TouchableOpacity>
      {showingChangeWorkoutName && (
        <AddWorkoutView
          isVisible={showingChangeWorkoutName}
          onClose={() => {
            setShowingChangeWorkoutName(false);
            onClose();
          }}
          workout={workout}
        />
      )}
      {showingDeleteAlert && (
        <CustomAlert
          isVisible={showingDeleteAlert}
          onClose={() => {
            setShowingDeleteAlert(false);
            onClose();
          }}
          title={deleteAlertTitle}
          text={deleteAlertText}
          action={deleteWorkout}
          specialCTA={"delete-string"}
        />
      )}
      {showingConflictingExercisesAlert && (
        <CustomAlert
          isVisible={showingConflictingExercisesAlert}
          onClose={() => setShowingConflictingExercisesAlert(false)}
          title={"conflictingExercisesTitle-string"}
          text={
            conflictNamesArray.length > 1
              ? t("conflictingExercisesText-string", {
                  slots: conflictingExerciseSlots,
                })
              : t("conflictingExerciseText-string", {
                  slot: conflictingExerciseSlots,
                })
          }
        />
      )}
    </View>
  );
});

export default WorkoutRowView;
